<template>
  <v-container fluid class="fill-height pa-0">
    <v-row>
      <v-col cols="12" xs="12" sm="12" md="12" lg="4" style="max-width:500px" class="ma-auto pa-10">
        <v-card outlined :loading="loading">
          <div class="px-4 pt-6 pb-12 justify-center">
            <v-card-title class="justify-center">
              <H2>TEST VERSİYONLARI</H2>
            </v-card-title>
            <v-card-text>
              <v-list elevation="20" two-line>
                <template v-for="(item, index) in products">
                  <v-list-item :to="'/test/product/' + item._id" v-if="item.name" :key="item._id">
                    <v-list-item-avatar>
                      <v-img :src="'../' + item.icon"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-html="item.name"></v-list-item-title>
                      <v-list-item-subtitle v-html="item.title"></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider v-else :key="index" :inset="item.inset"></v-divider>
                </template>
              </v-list>
            </v-card-text>
          </div>
        </v-card>
        <div class="mt-5 text-center">
          <img class="logo" style="max-height:30px" src="/logo.png" />
          <p>
            © {{ new Date().getFullYear() }}
          </p>
        </div>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar">
      {{ snackbarDesc }}
      <v-btn color="white" text @click="snackbar = false" icon>
        <v-icon>mdi-close-circle</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>

import moment from 'moment'
moment.locale('tr')

import ProductService from '@/services/ProductService'

export default {
  name: 'Home',
  data: () => ({
    loading: false,
    products: [],
    snackbarDesc: '',
    snackbar: false,

  }),
  methods: {
    
    showSnackbar(desc) {
      this.snackbarDesc = desc
      this.snackbar = true
    },

    async getProducts() {

      this.loading = true

      const products = await ProductService.getAllTestVersions()
        .catch((err) => {
          this.showSnackbar(err)
        })
        .finally(() => {
          this.loading = false
        })

      this.products = products.data.data

      if (typeof products === 'undefined') this.showSnackbar('Ürün Listesi Bulunamadı')

    },
    dateFormatter(date) {
      return moment(date).fromNow()
    }
  },
  mounted() {
    this.getProducts()
  }
}
</script>

<style lang="scss">
.card {
  background: #f9f9f9 !important;
}
</style>
